export default "__VITE_ASSET__BV0Wee7p__"